<template>
  <div class="user-data text-center">
    <small>
      Zalogowany jako: <br><router-link to="/account">
        {{ getUserName || 'Użytkownik' }}
      </router-link>
    </small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'user-data',
  computed: {
    ...mapGetters('user', [
      'getUserName'
    ])
  }
}
</script>

<style lang="scss">
.user-data {
  border-top: 1px solid var(--light);
  bottom: 5px;
  line-height: 32px;
  padding: 0.45rem 0.9375rem;
  position: absolute;
  width: 100%;

  a {
    display: block;
    font-weight: 700!important;
    line-height: 1.4!important;
  }
}
</style>
